<template>
    <div class="datetime-with-clear">
        <datetime
            v-bind="$attrs"
            :value="value"
            @input="$emit('input', $event)"
        ></datetime>
        <button
            v-if="value"
            type="button"
            class="clear-button"
            @click.prevent="clearValue"
            :aria-label="t('datetime-clear_date')"
            :title="t('datetime-clear_date')"
        >
            <Icon icon-class="ui-x-close" size="4" />
        </button>
    </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import Icon from "../icon/icon.vue";

export default {
    name: "datetime-with-clear",
    components: {
        datetime: Datetime,
        Icon,
    },
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        clearValue() {
            this.$emit("input", null);
        },
    },
};
</script>

<style scoped>
.datetime-with-clear {
    position: relative;
    display: inline-block;
    width: 100%;
}

.clear-button {
    position: absolute;
    right: 8px;
    top: 65%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    color: #999;
    font-size: 14px;
    line-height: 1;
    z-index: 10;
    transition: color 0.2s ease;
}

.clear-button:hover {
    color: #333;
}

.clear-button:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}
</style>
